import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { map } from 'rxjs/internal/operators/map';


@Injectable({ providedIn: 'root' })
export class APISupportLetter {
  constructor(
    private httpClient: HttpClient
  ) { }

  getGeneratedUploadDocuments(visatype, caseType, caseId, categoryCode) {
    return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/document/category/${categoryCode} `).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }


  UploadSupportLetter(visaType, caseType: any, caseId: number, docType, payload) {

    return this.httpClient.post(`/${visaType}/${caseType}/${caseId}/letter/${docType}/upload`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  deleteSupportLetter(documentId, companyId, petitionId) {
    return this.httpClient.delete(`/document/${documentId}/company/${companyId}/petition/${petitionId}`).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

  deleteCoverLetter(documentId, companyId, petitionId) {
    return this.httpClient.delete(`/green/card/document/${documentId}`).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }


  deleteSupportLetterGreenCard(documentId) {
    return this.httpClient.delete(`/green/card/document/${documentId}`).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }


  // GREENCARD

  UploadGreenCardSupportLetter(visaType, caseType: any, caseId: number, docType, payload) {

    return this.httpClient.post(`/task/${visaType}/case/${caseId}/letter/${docType}/upload`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  getGeneratedUploadGreenCardDocuments(visatype, caseType, caseId, categoryCode) {
    return this.httpClient.get(`/superTask/${visatype}/subTask/${caseType}/gc/i140Case/${caseId}/document/category/${categoryCode} `).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }



}